module.exports = __webpack_public_path__ + "static/media/Odysseus.e77084be.png";